/**
 * Unit toggle (cm ↔ inches) for product pages.
 * Converts variant labels, tech-specs, and subtitle text.
 * Auto-detects US visitors; remembers preference in localStorage.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'mb_unit';
  var CM_PER_INCH = 2.54;

  /* ── Conversion ── */

  function cmToHalfInch(cm) {
    return Math.round((cm / CM_PER_INCH) * 2) / 2;
  }

  function fmtIn(val) {
    if (val % 1 === 0.5) {
      var whole = Math.floor(val);
      return (whole > 0 ? whole : '') + '\u00BD'; // ½
    }
    return String(Math.round(val));
  }

  /** Convert a single cm number to formatted inches string. */
  function cmNum(n) {
    return fmtIn(cmToHalfInch(parseFloat(n.replace(',', '.'))));
  }

  /** Replace every  `<number> cm`  in a string with inches.
   *  Handles multi-number patterns like "160 x 75 x 74 cm". */
  function convertCmString(text) {
    // Pass 1: "N x N x N cm" (three-number dimensions)
    text = text.replace(
      /(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm\b/g,
      function (_, a, b, c) {
        return cmNum(a) + ' x ' + cmNum(b) + ' x ' + cmNum(c) + ' in';
      }
    );
    // Pass 2: "N x N cm" (two-number dimensions)
    text = text.replace(
      /(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm\b/g,
      function (_, a, b) {
        return cmNum(a) + ' x ' + cmNum(b) + ' in';
      }
    );
    // Pass 3: standalone "N cm"
    text = text.replace(/(\d+(?:[.,]\d+)?)\s*cm\b/g, function (_, n) {
      return cmNum(n) + ' in';
    });
    return text;
  }

  /** Convert bare numbers (no "cm" suffix) — used for dimensions_short like "160×75". */
  function convertBareNumbers(text) {
    return text.replace(/(\d+(?:[.,]\d+)?)/g, function (_, n) {
      return fmtIn(cmToHalfInch(parseFloat(n.replace(',', '.'))));
    });
  }

  /** Replace `(cm)` label with `(in)` in tech-specs heading. */
  function convertLabel(text) {
    return text.replace(/\(cm\)/gi, '(in)');
  }

  /* ── Preference ── */

  function getUnit() {
    return localStorage.getItem(STORAGE_KEY) || detectDefault();
  }
  function setUnit(u) {
    localStorage.setItem(STORAGE_KEY, u);
  }

  function detectDefault() {
    if (window.Shopify && window.Shopify.country === 'US') return 'in';
    return 'cm';
  }

  /* ── Original-text cache ── */

  var originals = new WeakMap();

  function storeOriginal(el, prop) {
    prop = prop || 'innerHTML';
    var key = '_orig_' + prop;
    if (!originals.has(el)) originals.set(el, {});
    var map = originals.get(el);
    if (!(key in map)) map[key] = el[prop];
  }

  function getOriginal(el, prop) {
    prop = prop || 'innerHTML';
    var map = originals.get(el);
    return map ? map['_orig_' + prop] : el[prop];
  }

  function clearOriginal(el, prop) {
    prop = prop || 'innerHTML';
    var map = originals.get(el);
    if (map) delete map['_orig_' + prop];
  }

  /* ── Size-section detection (mirrors Liquid logic) ── */

  var SIZE_KEYWORDS = [
    'dimensiones', 'tamano', 'medidas', 'largo', 'size',
    'taille', 'long', 'longues', 'longue', 'longe',
    'dimensions', 'medida'
  ];

  function isSizeSection(el) {
    var cls = (el.className || '').toLowerCase();
    for (var i = 0; i < SIZE_KEYWORDS.length; i++) {
      if (cls.indexOf(SIZE_KEYWORDS[i]) > -1) return true;
    }
    return false;
  }

  function findSizeSection() {
    var sections = document.querySelectorAll('[name="variant_section"]');
    for (var i = 0; i < sections.length; i++) {
      if (isSizeSection(sections[i])) return sections[i];
    }
    return null;
  }

  /* ── Apply / revert conversion ── */

  var _isApplying = false;

  function applyUnit(unit) {
    _isApplying = true;

    var isIn = unit === 'in';

    // 1. Variant radio labels
    var sizeSection = findSizeSection();
    if (sizeSection) {
      sizeSection.querySelectorAll('.attributes__item label').forEach(function (label) {
        if (isIn) {
          storeOriginal(label);
          label.innerHTML = convertCmString(getOriginal(label));
        } else {
          label.innerHTML = getOriginal(label);
        }
      });

      // Subtitle ("dimensions may vary +/- 1 cm")
      var sub = sizeSection.querySelector('.attributes__title__subtitle');
      if (sub) {
        if (isIn) { storeOriginal(sub); sub.innerHTML = convertCmString(getOriginal(sub)); }
        else { sub.innerHTML = getOriginal(sub); }
      }

      // Extra text below selector
      var txt = sizeSection.querySelector('.attributes__text');
      if (txt) {
        if (isIn) { storeOriginal(txt); txt.innerHTML = convertCmString(getOriginal(txt)); }
        else { txt.innerHTML = getOriginal(txt); }
      }
    }

    // 2. Specs dropdown buttons
    var dropdown = document.getElementById('specs-dim-dropdown');
    if (dropdown) {
      dropdown.querySelectorAll('.specs-dim-dropdown__option').forEach(function (btn) {
        if (isIn) { storeOriginal(btn, 'textContent'); btn.textContent = convertCmString(getOriginal(btn, 'textContent')); }
        else { btn.textContent = getOriginal(btn, 'textContent'); }
      });
    }

    // 3. Specs data fields
    applySpecField('dimensions_short', isIn, true);
    applySpecField('surface', isIn, false);
    applySpecField('legs', isIn, false);

    // 4. "Dimensions (cm)" label in specs hero
    document.querySelectorAll('.specs-hero__label').forEach(function (lbl) {
      var raw = lbl.childNodes[0]; // text node
      if (!raw || raw.nodeType !== 3) return;
      if (isIn) {
        storeOriginal(raw, 'textContent');
        raw.textContent = convertLabel(getOriginal(raw, 'textContent'));
      } else {
        raw.textContent = getOriginal(raw, 'textContent');
      }
    });

    // 5. Cart line item options — full cart page + sidebar notification
    var cartSelectors = '.cart__products__item__info__attributes p, .cart-notification__item-attrs span';
    document.querySelectorAll(cartSelectors).forEach(function (el) {
      var text = el.textContent || '';
      if (!/\d+\s*cm\b/.test(text) && !/\d+\s*in\b/.test(text)) return;
      if (isIn) {
        storeOriginal(el);
        el.innerHTML = convertCmString(getOriginal(el));
      } else {
        el.innerHTML = getOriginal(el);
      }
    });

    // 6. Toggle active state
    document.querySelectorAll('.unit-toggle__btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-unit') === unit);
    });

    setTimeout(function () { _isApplying = false; }, 0);
  }

  function applySpecField(attr, isIn, isBare) {
    document.querySelectorAll('[data-spec="' + attr + '"]').forEach(function (el) {
      if (el.textContent.trim() === '—' || el.textContent.trim() === '') return;
      if (isIn) {
        storeOriginal(el);
        var orig = getOriginal(el);
        el.innerHTML = isBare ? convertBareNumbers(orig) : convertCmString(orig);
      } else {
        el.innerHTML = getOriginal(el);
      }
    });
  }

  /* ── Toggle UI ── */

  function createToggle(container, beforeEl) {
    if (container.querySelector('.unit-toggle')) return;

    var toggle = document.createElement('span');
    toggle.className = 'unit-toggle';
    toggle.innerHTML =
      '<button type="button" class="unit-toggle__btn" data-unit="cm">cm</button>' +
      '<span class="unit-toggle__sep">/</span>' +
      '<button type="button" class="unit-toggle__btn" data-unit="in">in</button>';

    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-unit]');
      if (!btn) return;
      e.stopPropagation();
      e.preventDefault();
      var unit = btn.getAttribute('data-unit');
      setUnit(unit);
      applyUnit(unit);
    });

    if (beforeEl) {
      container.insertBefore(toggle, beforeEl);
    } else {
      container.appendChild(toggle);
    }
  }

  function insertToggles() {
    // Toggle in variant size title
    var sizeSection = findSizeSection();
    if (sizeSection) {
      var title = sizeSection.querySelector('.attributes__title');
      if (title) {
        createToggle(title, title.querySelector('svg'));
      }
    }
  }

  /* ── Observe spec re-renders ── */

  var _reapplyTimer = null;

  function observeSpecChanges() {
    var containers = [
      document.getElementById('specs-hero'),
      document.getElementById('specs-detail-grid')
    ].filter(Boolean);

    if (!containers.length) return;

    var observer = new MutationObserver(function () {
      if (_isApplying) return;
      clearTimeout(_reapplyTimer);
      _reapplyTimer = setTimeout(function () {
        if (getUnit() !== 'in') return;
        document.querySelectorAll('[data-spec]').forEach(function (el) {
          clearOriginal(el);
        });
        applyUnit('in');
      }, 150);
    });

    containers.forEach(function (c) {
      observer.observe(c, { childList: true, characterData: true, subtree: true });
    });
  }

  /** Watch the cart-notification sidebar for AJAX content injection. */
  function observeCartNotification() {
    var cartProducts = document.querySelector('.cart-notification__products');
    if (!cartProducts) return;

    var cartObserver = new MutationObserver(function () {
      if (_isApplying) return;
      if (getUnit() !== 'in') return;
      setTimeout(function () { applyUnit('in'); }, 50);
    });

    cartObserver.observe(cartProducts, { childList: true });
  }

  /* ── Styles ── */

  function injectStyles() {
    if (document.getElementById('unit-toggle-css')) return;
    var style = document.createElement('style');
    style.id = 'unit-toggle-css';
    style.textContent =
      '.unit-toggle{display:inline-flex;align-items:center;margin-left:auto;margin-right:8px;flex-shrink:0;gap:2px}' +
      '.unit-toggle__btn{background:none;border:none;padding:0;cursor:pointer;' +
        'font-family:inherit;font-size:10px;letter-spacing:.03em;' +
        'line-height:1;color:#999;transition:color .15s}' +
      '.unit-toggle__btn.is-active{color:#3E2C1E}' +
      '.unit-toggle__btn:hover{color:#3E2C1E}' +
      '.unit-toggle__sep{font-size:10px;color:#ccc;pointer-events:none;line-height:1}' +
      '@media(max-width:640px){.unit-toggle__btn,.unit-toggle__sep{font-size:12px}}';
    document.head.appendChild(style);
  }

  /* ── Init ── */

  function init() {
    injectStyles();
    insertToggles();
    applyUnit(getUnit());
    observeSpecChanges();
    observeCartNotification();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
